/**
 * Field shapes and validators shared by the application settings tabs.
 *
 * These live apart from any one tab because the fields they describe are split
 * across General (login path) and Advanced (environment variables), and are
 * read by the Environments tab and the external-suite config too.
 */

/** Declares a per-environment variable; values are set on each environment. */
export type EnvVarDefinition = {
  name: string;
  description?: string;
  sensitive?: boolean;
};

/** Relative path starting with `/` (or empty); never an absolute URL. */
export function isValidLoginPath(value: string): boolean {
  return value === '' || (value.startsWith('/') && !/^https?:\/\//i.test(value));
}
